export function resolveSiteTitle(configuredTitle, fallback = '') {
    return String(configuredTitle ?? '').trim() || fallback;
}

// Use the same configured title before and after the application starts.
export function createSiteTitleHtmlPlugin(configuredTitle) {
    const title = resolveSiteTitle(configuredTitle);
    return {
        name: 'site-document-title',
        transformIndexHtml() {
            if (!title) return [];
            const text = title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            return [{ tag: 'title', children: text, injectTo: 'head-prepend' }];
        },
    };
}
